import { APIUrlConstants, AppConstants } from '../../../common/APIConstants';
import RestEndPoint from '../../../common/RestEndPoint';

export default class GainLossReferenceAPI {
  static getReferenceHeaderData() {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetGainLossReferenceHeader,
      'GET',
      AppConstants.APP_BACKEND_HOST_KEY
    );
  }
  static getReferenceScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetGainLossReferenceData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static getProducts(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetGainLossProductsData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static saveReferenceScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveReferenceScreenData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static saveProductData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveProductData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
}
